// extracted by mini-css-extract-plugin
export default {"upload":"upload_aIYmN","record-img":"record-img_bnji5","sortable-chosen":"sortable-chosen_szR_v"};